export const RESPONDER = 'responder';
export const EXPERIENCE = 'experience';
export const WORKSHOP = 'workshop';
export const PUBLICATION = 'publication';
export const REALISATION = 'realisation';
export const FINISH = 'finish';
export const RESSOURCE = 'ressource';
export const RESULT = 'result';
